import React from "react";
import SignatureCapture from "./SignatureCapture";

/**
 * SignaturesManager
 * ------------------
 * Simple page wiring up two SignatureCapture instances - one for Jamie,
 * one for Neil. Add this to your navigationItems in App.js if you want
 * it as its own route, e.g.:
 *
 *   {
 *     id: "signatures",
 *     label: "Signatures",
 *     icon: Pen,
 *     component: SignaturesManager,
 *   }
 */
const SignaturesManager = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Signatures</h1>
        <p className="text-gray-600">
          Draw or upload a signature for Jamie and Neil. These are used when
          generating signed documents and contracts.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SignatureCapture signerName="Jamie" signerId="jamie" />
        <SignatureCapture signerName="Neil" signerId="neil" />
      </div>
    </div>
  );
};

export default SignaturesManager;